import { render, staticRenderFns } from "./SummaryInfo.vue?vue&type=template&id=1012262a&scoped=true"
import script from "./SummaryInfo.vue?vue&type=script&lang=js"
export * from "./SummaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012262a",
  null
  
)

export default component.exports